export const setFilters = (filters, temporary=false) => ({
  type: `filters/update`,
  filters,
  temporary,
})

export const setFilter = (key, value, temporary=false) => ({
  type: `filter/update`,
  key,
  value,
  temporary,
})
